import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import SendPanelWithRequestNoteWidget from '../../../widgets/sendPanelWithRequestNoteWidget/SendPanelWithRequestNoteWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSignContract } from '../../../redux/actions/contract'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import ContractSigningWidgets from '../../../widgets/ContractSigning/ContractSigningWidgets'
import {
  getDownloadContractPdf,
  getDownloadContractPdfRealtime,
} from '../../../redux/actions/contract'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import { Message } from 'rsuite'
import ContractSignTypeWidgets from '../../../widgets/ContractSignType/ContractSignTypeWidgets'

export default function DirectorOfferAuthorizedSignatory() {
  //ขั้นที่ 3 ส่งเสนอผู้มีอำนาจลงนาม
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  useEffect(() => {
    projectId && handleGetSchema(projectId)
    projectId && handleGetDownloadContractPdf(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSignContract(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetDownloadContractPdf = async (projectId) => {
    startLoading()
    //setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await getDownloadContractPdf(projectId, 'contract')
      console.log('response preview pdf', response)
      if (!response.success) {
        setPreviewPdf(response)
        setIsPdfError(false)
      }
    } catch (e) {
      try {
        const response = await getDownloadContractPdfRealtime(projectId)

        if (!response.success) {
          setPreviewPdf(response)
          setIsPdfError(false)
        } else {
          setIsPdfError(true)
        }
      } catch (error) {
        setIsPdfError(true)
      }
    }
    //setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets
            showCommandButton={true}
            formSchema={schema.forms.agreementDetails}
          />
        )}

        {schema.forms?.contractInfo && (
          <ContractSignTypeWidgets schema={schema.forms?.contractInfo || null} />
        )}

        {schema?.forms?.requestNote?.note && (
          <SendPanelWithRequestNoteWidget
            showCommandButton={!schema.forms.requestNote.disabled}
            schema={schema?.forms?.requestNote}
            isDirectorSendApprove={true}
          />
        )}

        {schema.forms?.contractorList && (
          <ContractSigningWidgets schema={schema.forms?.contractorList} />
        )}

        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
        ) : (
          <PdfRenderWidgets
            header={'สัญญา'}
            file={previewPdf}
            isLoading={isLoadingPDF}
            fileName={'สัญญา'}
            onReload={() => {
              handleGetDownloadContractPdf(projectId)
            }}
            loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF สัญญา...'}
          />
        )}
        <br />
      </SidebarProposal>
    </>
  )
}
